// extracted by mini-css-extract-plugin
export default {"safe-area-top":"safe-area-top--nnkjs","safe-area-bottom":"safe-area-bottom--udsQc"};